
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'tradelossrecordIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'tradelossrecord',
				windowName: 'tradelossrecord',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
